import { ChangeDetectionStrategy, Component, output, viewChild } from '@angular/core';
import { ModalComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { fadeInOut } from '../../../../../../assets/animations/animations';
import { PlatformTfaInputComponent } from '../tfa-input/platform-tfa-input.component';

@Component({
  selector: 'app-platform-tfa-app-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, TranslocoPipe, PlatformTfaInputComponent],
  templateUrl: './platform-tfa-app-modal.component.html',
  styleUrl: './platform-tfa-app-modal.component.scss',
  animations: [fadeInOut],
})
export class PlatformTfaAppModalComponent {
  readonly modal = viewChild.required<ModalComponent>('appModal');
  readonly tfaAppInput = viewChild.required<PlatformTfaInputComponent>('tfaAppInput');
  readonly closeEnd = output<void>();
  readonly submit = output<string>();

  /**
   * Opens the TOTP confirmation modal.
   */
  open(): void {
    this.modal().open();
  }

  /**
   * Closes the TOTP confirmation modal.
   */
  close(): void {
    this.modal().close();
  }

  /**
   * Focuses the TOTP input after the modal animation.
   */
  onOpenEnd(): void {
    this.tfaAppInput().focus();
  }

  /**
   * Resets the TOTP input when the modal finishes closing.
   */
  onCloseEnd(): void {
    this.tfaAppInput().reset();
    this.closeEnd.emit();
  }

  /**
   * Forwards a completed TOTP code.
   * @param code - Six-digit code
   */
  onSubmit(code: string): void {
    this.submit.emit(code);
  }

  /**
   * Marks the TOTP field as valid or invalid.
   * @param valid - Whether the code was accepted
   */
  validate(valid: boolean): void {
    this.tfaAppInput().validate(valid);
  }
}
